import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=fd203cda&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=fd203cda&prod&lang=scss&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=fd203cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd203cda",
  null
  
)

export default component.exports